import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import channelStore from "../../Store/ChannelStore";
import { toast } from "react-toastify";
import { BASE_API_URL } from "../const";
import Api from "../Api";
import MainProgrammaPeredach from "./MainProgrammaPeredach";
import MainWeeklyPeriods from "./MainWeeklyPeriods";
import MainBlockFillers from "./MainBlockFillers";
import { getErrorMessage } from "../../utils/errorHandler";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TableHead,
  Paper,
  Button,
  TextField,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  MenuItem,
  FormControl,
} from "@mui/material";

const MainButton = observer(({ setManageBlock, manageBlock, hideMetUid }) => {
  // Состояние для открытия/закрытия модального окна
  const [openAddEdit, setOpenAddEdit] = useState(false);
  const [openProgrammaPeredach, setOpenProgrammaPeredach] = useState(false);
  const [openWeeklyPeriods, setOpenWeeklyPeriods] = useState(false);
  const [openBlockFillers, setOpenBlockFillers] = useState(false);

  // Функции для открытия и закрытия модального окна
  const handleOpenAddEdit = () => {
    setOpenAddEdit(true);
  };

  const handleCloseAddEdit = () => {
    setOpenAddEdit(false);
    setFormData({
      id: "",
      name: "",
      ip: "",
      telnet_port: "",
      cid_iptvn: "",
      sort: "",
      visible_menu: "",
      rotation: "stream",
      rotation_step: null,
    });
  };
  const handleOpenProgrammaPeredach = () => {
    setOpenProgrammaPeredach(true);
  };

  const handleCloseProgrammaPeredach = () => {
    setOpenProgrammaPeredach(false);
  };

  const handleOpenWeeklyPeriods = () => {
    setOpenWeeklyPeriods(true);
  };

  const handleCloseWeeklyPeriods = () => {
    setOpenWeeklyPeriods(false);
  };

  const handleOpenBlockFillers = () => {
    setOpenBlockFillers(true);
  };

  const handleCloseBlockFillers = () => {
    setOpenBlockFillers(false);
  };

  // Загрузка списка каналов при монтировании
  useEffect(() => {
    channelStore.getChannels();
  }, []);

  // Обработчик нажатия на канал
  const handleClickChannel = (channel) => {
    const rotation = channel.rotation || "stream";
    const rotationStep = Number(channel.rotation_step);
    setFormData({
      id: channel.id,
      name: channel.name,
      ip: channel.ip,
      telnet_port: channel.telnet_port,
      cid_iptvn: channel.cid_iptvn,
      sort: channel.sort,
      visible_menu: channel.visible_menu,
      rotation,
      rotation_step:
        rotation === "stream"
          ? null
          : Number.isInteger(rotationStep)
          ? rotationStep
          : 0,
    });
  };

  // Массив данных для полей ввода (5 полей)
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    ip: "",
    telnet_port: "",
    cid_iptvn: "",
    sort: "",
    visible_menu: "",
    rotation: "stream",
    rotation_step: null,
  });

  // Обработчик изменений для полей ввода
  const handleInputChangeID = (e) => {
    setFormData((prev) => ({
      ...prev,
      id: e.target.value,
    }));
  };
  const handleInputChangeName = (e) => {
    setFormData((prev) => ({
      ...prev,
      name: e.target.value,
    }));
  };
  const handleInputChangeIP = (e) => {
    setFormData((prev) => ({
      ...prev,
      ip: e.target.value,
    }));
  };
  const handleInputChangeTelnetPort = (e) => {
    setFormData((prev) => ({
      ...prev,
      telnet_port: e.target.value,
    }));
  };
  const handleInputChangeCidIPTVN = (e) => {
    setFormData((prev) => ({
      ...prev,
      cid_iptvn: e.target.value,
    }));
  };
  const handleInputChangeSort = (e) => {
    setFormData((prev) => ({
      ...prev,
      sort: e.target.value,
    }));
  };
  const handleInputChangeVisibleMenu = (e) => {
    setFormData((prev) => ({
      ...prev,
      visible_menu: e.target.value,
    }));
  };
  const handleInputChangeRotation = (e) => {
    const rotation = e.target.value;
    setFormData((prev) => ({
      ...prev,
      rotation,
      rotation_step:
        rotation === "stream"
          ? null
          : prev.rotation_step !== null &&
            prev.rotation_step !== "" &&
            Number.isInteger(Number(prev.rotation_step))
          ? prev.rotation_step
          : 0,
    }));
  };

  const handleInputChangeRotationStep = (e) => {
    setFormData((prev) => ({
      ...prev,
      rotation_step: e.target.value,
    }));
  };

  const prepareChannelPayload = () => {
    if (formData.rotation === "stream") {
      return { ...formData, rotation_step: null };
    }

    const rotationStep = Number(formData.rotation_step);
    if (formData.rotation_step === "" || !Number.isInteger(rotationStep)) {
      toast.warning("Шаг ротации должен быть целым числом");
      return null;
    }

    return { ...formData, rotation_step: rotationStep };
  };

  const ButtonOnClickSend = async () => {
    if (!formData.name) {
      toast.warning("Имя канала обязательно");
      return;
    }
    const payload = prepareChannelPayload();
    if (!payload) return;

    try {
      await channelStore.addChannel(payload);
      toast.success("Канал успешно добавлен");
      setFormData({
        id: "",
        name: "",
        ip: "",
        telnet_port: "",
        cid_iptvn: "",
        sort: "",
        visible_menu: "",
        rotation: "stream",
        rotation_step: null,
      });
    } catch (error) {
      toast.error(getErrorMessage(error, "Не удалось добавить канал"));
    }
  };
  const ButtonOnClickEdit = async () => {
    if (!formData.id) {
      toast.warning("Выберите канал для редактирования");
      return;
    }
    const payload = prepareChannelPayload();
    if (!payload) return;

    try {
      await channelStore.updateChannel(formData.id, payload);
      toast.success("Канал успешно обновлён");
      setFormData({
        id: "",
        name: "",
        ip: "",
        telnet_port: "",
        cid_iptvn: "",
        sort: "",
        visible_menu: "",
        rotation: "stream",
        rotation_step: null,
      });
    } catch (error) {
      toast.error(getErrorMessage(error, "Не удалось обновить канал"));
    }
  };

  return (
    <Box
      sx={{
        border: "1px solid #ccc",
        marginTop: "10px",
      }}
    >
      <TableContainer component={Paper}>
        <Table>
          <TableBody>
            <TableRow key={0}>
              <TableCell>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleOpenAddEdit}
                >
                  Добавить / редактировать
                </Button>
              </TableCell>
            </TableRow>
            <TableRow key={1}>
              <TableCell>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleOpenProgrammaPeredach}
                >
                  Программа передач
                </Button>
              </TableCell>
            </TableRow>
            <TableRow key={2}>
              <TableCell>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleOpenWeeklyPeriods}
                >
                  Недельные планы
                </Button>
              </TableCell>
            </TableRow>
            <TableRow key={3}>
              <TableCell>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleOpenBlockFillers}
                >
                  Перебивки
                </Button>
              </TableCell>
            </TableRow>
            <TableRow key={4}>
              <TableCell>
                <Button
                  variant="contained"
                  fullWidth
                  color="primary"
                  onClick={() => setManageBlock((prev) => !prev)}
                  sx={{
                    backgroundColor: manageBlock ? "#1565c0" : "#1976d2",
                    borderColor: manageBlock ? "#1565c0" : "#1976d2",
                    borderWidth: 2,
                    borderStyle: "solid",
                    "&:hover": {
                      backgroundColor: manageBlock ? "#0d47a1" : "#1565c0",
                    },
                  }}
                >
                  {manageBlock ? "Основное окно" : "Управление блоками"}
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>

      {/* Модальное окно добавления и редактирования */}
      <Dialog open={openAddEdit} onClose={handleCloseAddEdit}>
        <DialogContent>
          <Box sx={{ display: "flex", gap: 4 }}>
            {/* Таблица с данными слева */}
            <Box sx={{ flex: 1 }}>
              <TableContainer sx={{ maxWidth: "100%", overflowX: "auto" }}>
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontSize: "1.1rem", // Увеличенный размер шрифта
                          fontWeight: "bold", // Жирный текст
                          textAlign: "center",
                        }}
                      >
                        Список каналов
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody
                    sx={{
                      "& .MuiTableCell-root": {
                        padding: "6px 8px", // Уменьшаем отступы
                      },
                    }}
                  >
                    {channelStore.channels.map((element, index) => (
                      <TableRow
                        key={index}
                        onClick={() => handleClickChannel(element)}
                        sx={{ cursor: "pointer", border: "1px solid #ddd" }}
                      >
                        <TableCell
                          sx={{
                            border: "1px solid #ddd",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {element.name}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>

            {/* Поля ввода справа */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: 1,
                fontSize: "1.1rem",
                fontWeight: "bold",
                textAlign: "center",
              }}
            >
              <Typography variant="h8" component="div" align="center">
                добавление / редактирование
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  id:
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.id}
                  onChange={(e) => handleInputChangeID(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  name:
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.name}
                  onChange={(e) => handleInputChangeName(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  ip:
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.ip}
                  onChange={(e) => handleInputChangeIP(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  telnet_port:
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.telnet_port}
                  onChange={(e) => handleInputChangeTelnetPort(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  cid_iptvn
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.cid_iptvn}
                  onChange={(e) => handleInputChangeCidIPTVN(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  sort
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.sort}
                  onChange={(e) => handleInputChangeSort(e)}
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  visible_menu
                </Typography>
                <TextField
                  sx={{
                    width: "200px",
                    "& .MuiOutlinedInput-root": {
                      height: "30px", // Задаем высоту
                      fontSize: "0.875rem", // Уменьшаем размер шрифта
                    },
                  }}
                  variant="outlined"
                  value={formData.visible_menu}
                  onChange={(e) => handleInputChangeVisibleMenu(e)}
                />
              </Box>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "left",
                  gap: 2,
                }}
              >
                <Typography variant="body1" sx={{ flexGrow: 1 }}>
                  rotation
                </Typography>
                <Select
                  sx={{
                    width: "200px",
                    height: "30px",
                    fontSize: "0.875rem",
                  }}
                  value={formData.rotation}
                  onChange={(e) => handleInputChangeRotation(e)}
                >
                  <MenuItem value="stream">Обычный потоковый канал</MenuItem>
                  <MenuItem value="lions">Lions</MenuItem>
                  <MenuItem value="block_serial">
                    Block Serial — сдвиг влево
                  </MenuItem>
                  <MenuItem value="block_film">
                    Block Film — сдвиг вправо
                  </MenuItem>
                </Select>
              </Box>

              {formData.rotation !== "stream" && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    textAlign: "left",
                    gap: 2,
                  }}
                >
                  <Typography variant="body1" sx={{ flexGrow: 1 }}>
                    rotation_step
                  </Typography>
                  <TextField
                    type="number"
                    variant="outlined"
                    value={formData.rotation_step ?? ""}
                    onChange={handleInputChangeRotationStep}
                    inputProps={{ step: 1 }}
                    sx={{
                      width: "200px",
                      "& .MuiOutlinedInput-root": {
                        height: "30px",
                        fontSize: "0.875rem",
                      },
                    }}
                  />
                </Box>
              )}

              {/* Блок с кнопкой "Редактировать и Отправить" */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 2,
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ButtonOnClickEdit}
                  disabled={channelStore.loading}
                  sx={{
                    marginRight: 2,
                  }}
                >
                  Редактировать
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={ButtonOnClickSend}
                  disabled={channelStore.loading}
                >
                  Добавить
                </Button>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Модальное окно программы передач */}
      <Dialog
        maxWidth="lg"
        PaperProps={{
          sx: {
            width: "1200px", // Фиксированная ширина
            height: "960px", // Фиксированная высота
            margin: "auto", // Центрирование
          },
        }}
        fullWidth
        open={openProgrammaPeredach}
        onClose={handleCloseProgrammaPeredach}
      >
        <DialogContent>
          <MainProgrammaPeredach
            responseListChannels={channelStore.channels}
            hideMetUid={hideMetUid}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        maxWidth="lg"
        PaperProps={{
          sx: {
            width: "1200px",
            height: "960px",
            margin: "auto",
          },
        }}
        fullWidth
        open={openWeeklyPeriods}
        onClose={handleCloseWeeklyPeriods}
      >
        <DialogContent>
          <MainWeeklyPeriods responseListChannels={channelStore.channels} />
        </DialogContent>
      </Dialog>

      <Dialog
        maxWidth="lg"
        fullWidth
        open={openBlockFillers}
        onClose={handleCloseBlockFillers}
        PaperProps={{ sx: { width: "1200px", minHeight: "850px" } }}
      >
        <DialogTitle>Перебивки</DialogTitle>
        <DialogContent>
          <MainBlockFillers open={openBlockFillers} />
        </DialogContent>
      </Dialog>
    </Box>
  );
});

export default MainButton;
